import { render, staticRenderFns } from "./ResourceModal.vue?vue&type=template&id=e2fa45ee&scoped=true"
import script from "./ResourceModal.vue?vue&type=script&lang=js"
export * from "./ResourceModal.vue?vue&type=script&lang=js"
import style0 from "./ResourceModal.vue?vue&type=style&index=0&id=e2fa45ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2fa45ee",
  null
  
)

export default component.exports